import { LEGAL_OPERATOR } from '@/content/legal/operator'

export const PUBLIC_OFFER_DEVFRONT2_EDITED_AT = '6 июня 2026 г.'

/** Маркетинговый A/B-стенд: оферта на заявку/лид, без тарифов подписки (прод с ценами — `publicOffer.ru.js` на `dev-front`). */
export const PUBLIC_OFFER_DEVFRONT2_SECTIONS = [
  {
    title: '1. Общие положения',
    paragraphs: [
      `Настоящий документ является публичным предложением ${LEGAL_OPERATOR.fullName} (далее — Исполнитель) о порядке взаимодействия с посетителями маркетингового сайта AI-Tenders.`,
      'Документ регулирует подачу заявок, обработку обращений и предоставление информации о возможностях сервиса.',
    ],
  },
  {
    title: '2. Предмет предложения',
    paragraphs: [
      'Исполнитель предоставляет посетителю информацию о сервисе AI-Tenders, проводит консультации и демонстрацию функционала по заявке.',
      'Взаимодействие осуществляется дистанционно через сайт, e-mail, телефон и иные каналы связи, согласованные с посетителем.',
    ],
  },
  {
    title: '3. Акцепт оферты',
    list: [
      'заполнение и отправка формы заявки на сайте;',
      'направление обращения на контактные реквизиты Исполнителя;',
      'фактическое использование сайта и его публичных материалов.',
    ],
  },
  {
    title: '4. Порядок обработки заявок',
    paragraphs: [
      'После получения заявки Исполнитель вправе связаться с посетителем для уточнения запроса и согласования дальнейшего взаимодействия.',
      'Срок и формат обратной связи зависят от полноты предоставленных данных и текущей загрузки специалистов.',
    ],
  },
  {
    title: '5. Права и обязанности сторон',
    list: [
      'Исполнитель обязуется использовать сведения из заявки только для целей обработки обращения и коммуникации;',
      'Посетитель обязуется предоставлять достоверные контактные данные;',
      'Стороны обязуются соблюдать требования законодательства Российской Федерации.',
    ],
  },
  {
    title: '6. Ограничение ответственности',
    paragraphs: [
      'Информация на сайте носит справочный характер и не является юридической консультацией.',
      'Исполнитель не несет ответственности за решения, принятые посетителем на основании материалов сайта без дополнительной экспертизы.',
    ],
  },
  {
    title: '7. Персональные данные',
    paragraphs: [
      'Обработка персональных данных осуществляется в соответствии с Политикой обработки персональных данных, размещенной по адресу /privacy.',
      'Отправляя заявку, посетитель подтверждает согласие на обработку персональных данных в объеме, необходимом для обратной связи.',
    ],
  },
  {
    title: '8. Заключительные положения',
    paragraphs: [
      'К отношениям сторон применяется право Российской Федерации.',
      `По вопросам взаимодействия обращайтесь на ${LEGAL_OPERATOR.email} или по телефону ${LEGAL_OPERATOR.phone}.`,
      `Место рассмотрения споров: ${LEGAL_OPERATOR.location}, если иное не установлено законодательством.`,
      'Тарифы подписки, докупка токенов и оплата через сервис публикуются в оферте на основном сайте https://ai-tenders.ru/offer.',
    ],
  },
]
